export default __webpack_public_path__ + "8bbfe24602d4dd64f5270ddc636124b4.png";